import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiService, Device} from "../../service/api.service";

@Component({
  selector: 'app-site-list',
  templateUrl: './site-list.component.html',
  styleUrls: ['./site-list.component.css']
})
export class SiteListComponent implements OnInit {
  devices: any = [];
  activeDevice: Device;

  @Output() selectedEvent = new EventEmitter<Device>();

  constructor(
    public apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.getDevices();
    this.activeDevice = this.devices[0];
  }

  getDevices() {
    return this.apiService.getDevices().subscribe((data: {}) => {
      this.devices = data;
    })
  }

  onClickLocation(evt: any) {
    this.activeDevice = this.devices.find(e => e.city === evt.target.id);
    this.updateParent();
  }

  updateParent() {
    this.selectedEvent.emit(this.activeDevice);
  }
}
